/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_Taiyoro_HrefInputs */

const ja_home_brands_taiyoro_href = /** @type {(inputs: Home_Brands_Taiyoro_HrefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://taiyoro.gg`)
};

const en_home_brands_taiyoro_href = /** @type {(inputs: Home_Brands_Taiyoro_HrefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://taiyoro.gg`)
};

/**
* | output |
* | --- |
* | "https://taiyoro.gg" |
*
* @param {Home_Brands_Taiyoro_HrefInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_taiyoro_href = /** @type {((inputs?: Home_Brands_Taiyoro_HrefInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_Taiyoro_HrefInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_taiyoro_href(inputs)
	return en_home_brands_taiyoro_href(inputs)
});